export enum ContractDuration {
    Day = 'day',
    Month = 'month',
    Year = 'year',
    Forever = 'forever',
}
